module.exports = __webpack_public_path__ + "6b22cf29c5d558443e88e7fbca387c6e.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/url-loader?limit=1!./src/assets/icons/safari_app_icon.png
// module id = 1466
// module chunks = 1